import { forEachObj } from 'remeda'
import { useRoute } from 'vue-router'
import { useMediumSource } from '@/composables/app/gtm/useMediumSource'
import { useCookies } from '@/plugins/cookie-plugin'

const attributionParamsNames = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
] as const

const prefix = 'attr_' as const

type AttributionParamNames = (typeof attributionParamsNames)[number]
type AttributionParams = Record<AttributionParamNames, string>
type AttributionParamsPrefixed = {
    [Property in keyof AttributionParams as `attr_${Property}`]: AttributionParams[Property]
}

const toPrefixed = (
    param: keyof AttributionParams
): keyof AttributionParamsPrefixed => `attr_${param}`
const fromPrefixed = (
    param: keyof AttributionParamsPrefixed
): keyof AttributionParams =>
    param.replace(prefix, '') as keyof AttributionParams

export function useAttributionParams(): void {
    const attributionParams = useCookies(
        attributionParamsNames.reduce(
            (acc, paramName) => ({
                ...acc,
                [toPrefixed(paramName)]: '',
            }),
            {} as AttributionParamsPrefixed
        )
    )

    const query = useRoute().query

    forEachObj(attributionParams, (_, paramName) => {
        const urlParam = query[fromPrefixed(paramName)]?.toString()

        if (urlParam) {
            attributionParams[paramName].value = urlParam
        }
    })

    const { medium, source } = useMediumSource()

    attributionParams.attr_utm_medium.value ||= medium
    attributionParams.attr_utm_source.value ||= source
}
